import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Environment } from 'src/environments/environment.model';

import {
  FeedAdvice,
  GetFeedAdvicesResponse,
  GetReferenceSchemesResponse,
  UpsertFeedAdviceResponse,
} from '../models/feed-advice.model';

@Injectable({
  providedIn: 'root',
})
export class FeedAdviceService {
  private baseUrl = `${this.env.API_BASE_URL}/service/poultry-feed-advice/secure/feedadvice`;

  constructor(
    private readonly http: HttpClient,
    @Inject(EnvironmentInjector) private readonly env: Environment,
  ) {}

  getFeedAdviceById(id: number): Observable<FeedAdvice | HttpErrorResponse> {
    return this.http.get<FeedAdvice>(`${this.baseUrl}/${id}`).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<FeedAdvice>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  public getFeedAdvices(): Observable<FeedAdvice[] | HttpErrorResponse> {
    return this.http.get<GetFeedAdvicesResponse>(this.baseUrl + '/type/Layer').pipe(
      map((response) => response.feedAdvices),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<FeedAdvice[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  public deleteFeedAdvice(feedAdviceId: number) {
    return this.http.delete(`${this.baseUrl}/${feedAdviceId}`);
  }

  public getReferenceSchemes(country: string): Observable<FeedAdvice[] | HttpErrorResponse> {
    return this.http
      .get<GetReferenceSchemesResponse>(this.baseUrl + '/referenceScheme/' + country + 'type/Layer')
      .pipe(
        map((response) => response.referenceSchemes),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of(<FeedAdvice[]>[]);
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }

  public upsertFeedAdvice(
    feedAdvice: FeedAdvice,
  ): Observable<UpsertFeedAdviceResponse | HttpErrorResponse> {
    return this.http.post<UpsertFeedAdviceResponse>(`${this.baseUrl}`, feedAdvice, {}).pipe(
      map((d) => d),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<UpsertFeedAdviceResponse>{});
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }
}
